export default "__VITE_PUBLIC_ASSET__711372b1__"